export default "__VITE_ASSET__BFCQvY8Y__ 640w, __VITE_ASSET__ohGBE6jq__ 1024w, __VITE_ASSET__CdRkHe2R__ 1280w";